/** Matches ui-prototype-all sidebar-renderer.js admin menu */
export const ADMIN_NAV = [
  { path: '/admin/registration', label: 'Registration Review', icon: 'userPlus', badgeKey: 'pending_registrations', twoLine: true },
  { path: '/admin/payments', label: 'Payment Review', icon: 'creditCard', badgeKey: 'pending_payment_orders', twoLine: true },
  { path: '/admin/users', label: 'User List', icon: 'users' },
  { path: '/admin/companies', label: 'Company Management', icon: 'building2' },
  { path: '/admin/suspended', label: 'Suspended Users', icon: 'moderation' },
  { type: 'divider' },
  { path: '/admin/listings', label: 'Deal Listing', icon: 'listings' },
  { path: '/admin/pipeline', label: 'Fundraising Pipeline', icon: 'chart' },
  { type: 'divider' },
  { path: '/admin/messages', label: 'Messages & Compliance', icon: 'inbox', badgeKey: 'pending_compliance' },
  { path: '/admin/chat', label: 'Chat', icon: 'chat', badgeKey: 'admin_chat_unread' },
  { path: '/admin/email', label: 'Email', icon: 'email' },
  { path: '/admin/files', label: 'Files', icon: 'files' },
  { path: '/admin/digest', label: 'Digest', icon: 'digest' },
  { type: 'divider' },
  { path: '/admin/analytics', label: 'Analytics', icon: 'barChart' },
  { type: 'divider' },
  { path: '/admin/security', label: 'Security Rules', icon: 'shield' },
  { path: '/admin/profile', label: 'My Profile', icon: 'user' },
  { path: '/admin/settings', label: 'Platform Settings', icon: 'settings' },
]
